import { authenticatedRequest, unauthenticatedRequest } from 'utils/api';
import basicFlow, { genericErrorHandler } from './asyncHandler';
import * as actions from 'reducers/compradores.reducer';
import { routeWatcher } from './rotas.saga';
import { put, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { actions as routeActions, types as routes } from '../reducers/rotas.actions';

import { getPayload } from 'selectors/routes.selectors';
import { removeNonDigitsFromString, normalizeCpfCnpj } from 'utils/basic';
import formatters from 'utils/formatters';
import { dominioSelectors } from 'selectors/index';

const apiBuscarConjuge = ({ value }) => {
  return authenticatedRequest({
    url: `/participante/buscar-conjuge?idOportunidade=${value.idOportunidade}&cpf=${value.cpf}`,
    method: 'get'
  });
};

const apiMostrarParticipante = ({ value }) => {
  return authenticatedRequest({
    url: `/participante/show?idParticipante=${value.idParticipante}&idOportunidade=${value.idOportunidade}&tipoPessoa=${value.tipoPessoa}&tipoSituacao=A&tipoQualificacao=CO`,
    method: 'get'
  });
};

const apiRemoverParticipante = ({ value }) => {
  return authenticatedRequest({
    url: `/participante/delete/${value.id}`,
    method: 'put',
    body: value
  });
};

const apiListarCompradores = (values) => {
  return authenticatedRequest({
    url: `/participante/list?idOportunidade=${values}&tipoQualificacao=CO&tipoSituacao=A`,
    method: 'get'
  });
};

const apiCriarParticipante = ({ value }) => {
  const payload = {
    ...value,
    dataHoraAlteracao: new Date().toISOString(),
    dataRegistroEmpresa: formatters.dates.stringDateToDate(
      value.dataRegistroEmpresa
    ),
    cpfCnpj: normalizeCpfCnpj(value.cpfCnpj),
    cep: removeNonDigitsFromString(value.cep),
    celular: removeNonDigitsFromString(value.celular),
    dataNascimento: formatters.dates.stringDateToDate(value.dataNascimento),
    dataNascimentoConjuge: formatters.dates.stringDateToDate(
      value.dataNascimentoConjuge
    ),
    dataExpedicao: formatters.dates.stringDateToDate(value.dataExpedicao),
    dataExpedicaoConjuge: formatters.dates.stringDateToDate(
      value.dataExpedicaoConjuge
    ),

    cpfConjuge: removeNonDigitsFromString(value.cpfConjuge)
  };

  if (typeof payload.uf === 'object') {
    payload.uf = payload?.uf?.codigo;
  }

  if (typeof payload.idBanco === 'object') {
    payload.idBanco = payload?.idBanco?.idBanco ?? null;
  }

  if (typeof payload.tipoEmpresa === 'object') {
    payload.tipoEmpresa = payload?.tipoEmpresa?.value ?? null;
  }

  if (typeof payload.ufExpedicao === 'object') {
    payload.ufExpedicao = payload?.ufExpedicao?.codigo ?? null;
  }

  if (typeof payload.ufExpedicaoConjuge === 'object') {
    payload.ufExpedicaoConjuge = payload?.ufExpedicaoConjuge?.codigo ?? null;
  }

  if (typeof payload.tipoEstadoCivil === 'object') {
    payload.tipoEstadoCivil = payload?.tipoEstadoCivil?.id ?? null;
  }

  if (typeof payload.tipoEstadoCivilConjuge === 'object') {
    payload.tipoEstadoCivilConjuge =
      payload?.tipoEstadoCivilConjuge?.id ?? null;
  }

  if (typeof payload.tipoSexo === 'object') {
    payload.tipoSexo = payload?.tipoSexo?.id ?? null;
  }

  if (typeof payload.tipoRegimeCasamento === 'object') {
    payload.tipoRegimeCasamento = payload?.tipoRegimeCasamento?.id ?? null;
  }

  if (typeof payload.tipoDocumentoIdentidadeConjuge === 'object') {
    payload.tipoDocumentoIdentidadeConjuge =
      payload?.tipoDocumentoIdentidadeConjuge?.id ?? null;
  }

  if (typeof payload.tipoDocumentoIdentidade === 'object') {
    payload.tipoDocumentoIdentidade =
      payload?.tipoDocumentoIdentidade?.id ?? null;
  }

  if (typeof payload.idBanco === 'object') {
    payload.idBanco = payload?.idBanco?.idBanco ?? null;
  }

  if (typeof payload.tipoSexoConjuge === 'object') {
    payload.tipoSexoConjuge = payload?.tipoSexoConjuge?.id ?? null;
  }

  return authenticatedRequest({
    url: '/participante/create',
    method: 'post',
    body: payload
  });
};

const apiEditarParticipante = ({ value }) => {
  const payload = {
    ...value,
    dataHoraAlteracao: new Date().toISOString(),
    dataRegistroEmpresa: formatters.dates.stringDateToDate(
      value.dataRegistroEmpresa
    ),
    cpfCnpj: normalizeCpfCnpj(value.cpfCnpj),
    cep: removeNonDigitsFromString(value.cep),
    celular: removeNonDigitsFromString(value.celular),
    dataNascimento: formatters.dates.stringDateToDate(value.dataNascimento),
    dataNascimentoConjuge: formatters.dates.stringDateToDate(
      value.dataNascimentoConjuge
    ),
    dataExpedicaoConjuge: formatters.dates.stringDateToDate(
      value.dataExpedicaoConjuge
    ),
    dataExpedicao: formatters.dates.stringDateToDate(value.dataExpedicao),
    cpfConjuge: removeNonDigitsFromString(value.cpfConjuge)
  };

  if (typeof payload.uf === 'object') {
    payload.uf = payload?.uf?.codigo;
  }

  if (typeof payload.idBanco === 'object') {
    payload.idBanco = payload?.idBanco?.idBanco ?? null;
  }

  if (typeof payload.tipoEmpresa === 'object') {
    payload.tipoEmpresa = payload?.tipoEmpresa?.value ?? null;
  }

  if (typeof payload.ufExpedicao === 'object') {
    payload.ufExpedicao = payload?.ufExpedicao?.codigo ?? null;
  }

  if (typeof payload.ufExpedicaoConjuge === 'object') {
    payload.ufExpedicaoConjuge = payload?.ufExpedicaoConjuge?.codigo ?? null;
  }

  if (typeof payload.tipoEstadoCivil === 'object') {
    payload.tipoEstadoCivil = payload?.tipoEstadoCivil?.id ?? null;
  }

  if (typeof payload.tipoEstadoCivilConjuge === 'object') {
    payload.tipoEstadoCivilConjuge =
      payload?.tipoEstadoCivilConjuge?.id ?? null;
  }

  if (typeof payload.tipoSexo === 'object') {
    payload.tipoSexo = payload?.tipoSexo?.id ?? null;
  }

  if (typeof payload.tipoRegimeCasamento === 'object') {
    payload.tipoRegimeCasamento = payload?.tipoRegimeCasamento?.id ?? null;
  }

  if (typeof payload.tipoDocumentoIdentidadeConjuge === 'object') {
    payload.tipoDocumentoIdentidadeConjuge =
      payload?.tipoDocumentoIdentidadeConjuge?.id ?? null;
  }

  if (typeof payload.tipoDocumentoIdentidade === 'object') {
    payload.tipoDocumentoIdentidade =
      payload?.tipoDocumentoIdentidade?.id ?? null;
  }

  if (typeof payload.idBanco === 'object') {
    payload.idBanco = payload?.idBanco?.idBanco ?? null;
  }

  if (typeof payload.tipoSexoConjuge === 'object') {
    payload.tipoSexoConjuge = payload?.tipoSexoConjuge?.id ?? null;
  }

  return authenticatedRequest({
    url: `/participante/update/${value.idParticipante}`,
    method: 'put',
    body: payload
  });
};

const apiRemoverRepresentante = ({ value }) => {
  return authenticatedRequest({
    url: `/representante/delete/${value.id}`,
    method: 'put',
    body: value
  });
};

const apiCriarRepresentante = ({ value }) => {
  const payload = {
    ...value,
    dataHoraAlteracao: new Date().toISOString(),
    dataNascimento: formatters.dates.stringDateToDate(value.dataNascimento),
    dataExpedicao: formatters.dates.stringDateToDate(value.dataExpedicao),
    cpf: removeNonDigitsFromString(value.cpf),
    cep: removeNonDigitsFromString(value.cep),
    celular: removeNonDigitsFromString(value.celular)
  };

  if (typeof payload.uf === 'object') {
    payload.uf = payload?.uf?.codigo;
  }

  if (typeof payload.ufExpedicao === 'object') {
    payload.ufExpedicao = payload?.ufExpedicao?.codigo ?? null;
  }

  if (typeof payload.tipoEstadoCivil === 'object') {
    payload.tipoEstadoCivil = payload?.tipoEstadoCivil?.id ?? null;
  }

  if (typeof payload.tipoSexo === 'object') {
    payload.tipoSexo = payload?.tipoSexo?.id ?? null;
  }

  if (typeof payload.tipoDocumentoIdentidade === 'object') {
    payload.tipoDocumentoIdentidade =
      payload?.tipoDocumentoIdentidade?.id ?? null;
  }

  return authenticatedRequest({
    url: '/representante/create',
    method: 'post',
    body: payload
  });
};

const apiEditarRepresentante = ({ value }) => {
  const payload = {
    ...value,
    dataHoraAlteracao: new Date().toISOString(),
    dataNascimento: formatters.dates.stringDateToDate(value.dataNascimento),
    dataExpedicao: formatters.dates.stringDateToDate(value.dataExpedicao),
    cpf: removeNonDigitsFromString(value.cpf),
    cep: removeNonDigitsFromString(value.cep),
    celular: removeNonDigitsFromString(value.celular)
  };

  if (typeof payload.uf === 'object') {
    payload.uf = payload?.uf?.codigo;
  }

  if (typeof payload.ufExpedicao === 'object') {
    payload.ufExpedicao = payload?.ufExpedicao?.codigo ?? null;
  }

  if (typeof payload.tipoEstadoCivil === 'object') {
    payload.tipoEstadoCivil = payload?.tipoEstadoCivil?.id ?? null;
  }

  if (typeof payload.tipoSexo === 'object') {
    payload.tipoSexo = payload?.tipoSexo?.id ?? null;
  }

  if (typeof payload.tipoDocumentoIdentidade === 'object') {
    payload.tipoDocumentoIdentidade =
      payload?.tipoDocumentoIdentidade?.id ?? null;
  }

  return authenticatedRequest({
    url: `/representante/update/${value.idRepresentante}`,
    method: 'put',
    body: payload
  });
};

const apiMostrarRepresentante = ({ value }) => {
  return authenticatedRequest({
    url: `/representante/show?idRepresentante=${value.idRepresentante}&idParticipante=${value.idParticipante}&tipoSituacao=${value.tipoSituacao}`,
    method: 'get'
  });
};

const buscarConjuge = basicFlow({
  actionGenerator: actions.buscarConjugeRequest,
  actionFailure: actions.buscarConjugeFailure,
  actionSuccess: actions.buscarConjugeSuccess,
  api: apiBuscarConjuge,
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const criarRepresentante = basicFlow({
  actionGenerator: actions.criarRepresentanteRequest,
  actionFailure: actions.criarRepresentanteFailure,
  actionSuccess: actions.criarRepresentanteSuccess,
  api: apiCriarRepresentante,
  postSuccess: function* ({ response, original }) {
    const { id, idPessoaJuridica } = yield select(getPayload);

    yield put(
      routeActions.redirectTo(routes.REPRESENTANTE, {
        id: id,
        idPessoaJuridica: idPessoaJuridica,
        idRepresentante: response.data.idRepresentante
      })
    );
    toast.info('Representante criado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const editarRepresentante = basicFlow({
  actionGenerator: actions.editarRepresentanteRequest,
  actionFailure: actions.editarRepresentanteFailure,
  actionSuccess: actions.editarRepresentanteSuccess,
  api: apiEditarRepresentante,
  postSuccess: function* ({ response, original }) {
    const { id, idPessoaJuridica, idRepresentante } = yield select(getPayload);

    yield put(
      routeActions.redirectTo(routes.REPRESENTANTE, {
        id: id,
        idPessoaJuridica: idPessoaJuridica,
        idRepresentante: idRepresentante
      })
    );

    toast.info('Representante editado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const removerRepresentante = basicFlow({
  actionGenerator: actions.removerRepresentanteRequest,
  actionFailure: actions.removerRepresentanteFailure,
  actionSuccess: actions.removerRepresentanteSuccess,
  api: apiRemoverRepresentante,
  postSuccess: function* ({ response, original }) {
    const { id, idPessoaJuridica } = yield select(getPayload);
    yield put(
      actions.mostrarCompradorPessoaJuridicaRequest({
        value: {
          idParticipante: idPessoaJuridica,
          idOportunidade: id,
          tipoPessoa: 'J'
        }
      })
    );
    toast.info('Representante deletado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const removerParticipante = basicFlow({
  actionGenerator: actions.removerParticipanteRequest,
  actionFailure: actions.removerParticipanteFailure,
  actionSuccess: actions.removerParticipanteSuccess,
  api: apiRemoverParticipante,
  postSuccess: function* ({ response, original }) {
    const { id } = yield select(getPayload);
    yield put(actions.listarCompradoresRequest(id));
    toast.info('Participante deletado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const mostrarRepresentate = basicFlow({
  actionGenerator: actions.mostrarRepresentanteRequest,
  actionFailure: actions.mostrarRepresentanteFailure,
  actionSuccess: actions.mostrarRepresentanteSuccess,

  api: apiMostrarRepresentante,
  postSuccess: function* ({ response, original }) {
    const ufs = yield select(dominioSelectors.getUfs);
    const tiposSexo = yield select(dominioSelectors.getTiposSexo);
    const tiposDocumentos = yield select(dominioSelectors.getIiposDocumentos);
    const tiposEstadoCivil = yield select(dominioSelectors.getTiposEstadoCivil);

    const uf = ufs.find((el) => el.codigo === response.data.uf);
    const ufExpedicao = ufs.find(
      (el) => el.codigo === response.data.ufExpedicao
    );
    const tipoSexo = tiposSexo.find((el) => el.id === response.data.tipoSexo);
    const tipoDocumentoIdentidade = tiposDocumentos.find(
      (el) => el.id === response.data.tipoDocumentoIdentidade
    );
    const dataNascimento = formatters.dates.revert(
      response.data.dataNascimento
    );

    const dataExpedicaoConjuge = formatters.dates.revert(
      response.data.dataExpedicaoConjuge
    );
    const dataExpedicao = formatters.dates.revert(response.data.dataExpedicao);
    const tipoEstadoCivil = tiposEstadoCivil.find(
      (el) => el.id === response.data.tipoEstadoCivil
    );

    const formattedResponse = {
      ...response.data,
      uf,
      ufExpedicao,
      tipoSexo,
      tipoDocumentoIdentidade,
      dataNascimento,
      dataExpedicao,
      tipoEstadoCivil,
      dataExpedicaoConjuge
    };

    response.data = formattedResponse;

    yield put(actions.formatarRepresentante(formattedResponse));

    if (original.successCallback) {
      yield original.successCallback(response, original.value);
    }
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const listarCompradores = basicFlow({
  actionGenerator: actions.listarCompradoresRequest,
  actionFailure: actions.listarCompradoresFailure,
  actionSuccess: actions.listarCompradoresSuccess,
  api: apiListarCompradores,
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const mostrarCompradorPessoaFisica = basicFlow({
  actionGenerator: actions.mostrarCompradorPessoaFisicaRequest,
  actionFailure: actions.mostrarCompradorPessoaFisicaFailure,
  actionSuccess: actions.mostrarCompradorPessoaFisicaSuccess,
  api: apiMostrarParticipante,
  postSuccess: function* ({ response, original }) {
    const ufs = yield select(dominioSelectors.getUfs);
    const tiposBanco = yield select(dominioSelectors.getBancos);
    const tiposEstadoCivil = yield select(dominioSelectors.getTiposEstadoCivil);
    const tiposSexo = yield select(dominioSelectors.getTiposSexo);
    const tiposDocumentos = yield select(dominioSelectors.getIiposDocumentos);
    const tiposRegimeCasamento = yield select(
      dominioSelectors.getTiposRegimeCasamento
    );

    const utilizaFgts = response.data.utilizaFgts === 'S';

    const uf = ufs.find((el) => el.codigo === response.data.uf);
    const idBanco = tiposBanco.find(
      (el) => el.idBanco === response.data.idBanco
    );

    const ufExpedicao = ufs.find(
      (el) => el.codigo === response.data.ufExpedicao
    );

    const ufExpedicaoConjuge = ufs.find(
      (el) => el.codigo === response.data.ufExpedicaoConjuge
    );

    const tipoEstadoCivil = tiposEstadoCivil.find(
      (el) => el.id === response.data.tipoEstadoCivil
    );

    const tipoEstadoCivilConjuge = tiposEstadoCivil.find(
      (el) => el.id === response.data.tipoEstadoCivilConjuge
    );

    const tipoSexo = tiposSexo.find((el) => el.id === response.data.tipoSexo);

    const tipoDocumentoIdentidadeConjuge = tiposDocumentos.find(
      (el) => el.id === response.data.tipoDocumentoIdentidadeConjuge
    );

    const tipoDocumentoIdentidade = tiposDocumentos.find(
      (el) => el.id === response.data.tipoDocumentoIdentidade
    );

    const tipoRegimeCasamento = tiposRegimeCasamento.find(
      (el) => el.id === response.data.tipoRegimeCasamento
    );

    const dataNascimento = formatters.dates.revert(
      response.data.dataNascimento
    );

    const dataNascimentoConjuge = formatters.dates.revert(
      response.data.dataNascimentoConjuge
    );

    const dataExpedicao = formatters.dates.revert(response.data.dataExpedicao);

    const dataExpedicaoConjuge = formatters.dates.revert(
      response.data.dataExpedicaoConjuge
    );

    const tipoSexoConjuge = tiposSexo.find(
      (el) => el.id === response.data.tipoSexoConjuge
    );

    const formattedResponse = {
      ...response.data,
      uf,
      ufExpedicao,
      ufExpedicaoConjuge,
      dataNascimento,
      dataNascimentoConjuge,
      dataExpedicao,
      dataExpedicaoConjuge,
      tipoEstadoCivil,
      tipoEstadoCivilConjuge,
      tipoSexo,
      tipoDocumentoIdentidadeConjuge,
      tipoDocumentoIdentidade,
      tipoRegimeCasamento,
      tipoSexoConjuge,
      idBanco,
      utilizaFgts,
      // Mantemos renda como number cru. O CurrencyTextField/NumericFormat
      // faz a formatacao visual ("R$ 15.000,00"); pre-formatar aqui pra
      // "15.000" (string locale-BR) faz a lib interpretar "." como ponto
      // decimal e estraga o valor (15000 vira 15).
      renda: response.data.renda
    };

    response.data = formattedResponse;

    yield put(actions.formatarPessoaFisica(formattedResponse));

    if (original.successCallback) {
      yield original.successCallback(response, original.value);
    }
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const criarCompradorPessoaFisica = basicFlow({
  actionGenerator: actions.criarCompradorPessoaFisicaRequest,
  actionFailure: actions.criarCompradorPessoaFisicaFailure,
  actionSuccess: actions.criarCompradorPessoaFisicaSuccess,
  api: apiCriarParticipante,
  postSuccess: function* ({ response, original, values }) {
    if (original.successCallback) {
      yield original.successCallback(response, original.data);
    }
    yield put(
      routeActions.redirectTo(routes.PESSOA_FISICA, {
        id: values.value.idOportunidade,
        idPessoaFisica: response.data.idParticipante
      })
    );
    toast.info('Comprador cadastrado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const editarCompradorPessoaFisica = basicFlow({
  actionGenerator: actions.editarCompradorPessoaFisicaRequest,
  actionFailure: actions.editarCompradorPessoaFisicaFailure,
  actionSuccess: actions.editarCompradorPessoaFisicaSuccess,
  api: apiEditarParticipante,
  postSuccess: function* ({ response, original, values }) {
    if (original.successCallback) {
      yield original.successCallback(response, original.data);
    }
    yield put(
      routeActions.redirectTo(routes.PESSOA_FISICA, {
        id: values.value.idOportunidade,
        idPessoaFisica: values.value.idParticipante
      })
    );
    toast.info('Comprador editado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const mostrarCompradorPessoaJuridica = basicFlow({
  actionGenerator: actions.mostrarCompradorPessoaJuridicaRequest,
  actionFailure: actions.mostrarCompradorPessoaJuridicaFailure,
  actionSuccess: actions.mostrarCompradorPessoaJuridicaSuccess,
  api: apiMostrarParticipante,
  postSuccess: function* ({ response, original }) {
    const ufs = yield select(dominioSelectors.getUfs);
    const tiposBanco = yield select(dominioSelectors.getBancos);
    const tiposEmpresa = yield select(dominioSelectors.getTiposEmpresa);

    const uf = ufs.find((el) => el.codigo === response.data.uf);
    const idBanco = tiposBanco.find(
      (el) => el.idBanco === response.data.idBanco
    );
    const dataRegistroEmpresa = formatters.dates.revert(
      response.data.dataRegistroEmpresa
    );
    const tipoEmpresa = tiposEmpresa.find(
      (el) => el.value === response.data.tipoEmpresa
    );

    const formattedResponse = {
      ...response.data,
      uf,
      idBanco,
      tipoEmpresa,
      dataRegistroEmpresa,
      // Valores monetarios mantidos como number cru — o CurrencyTextField
      // faz a formatacao visual. Pre-formatar pra string locale-BR ("15.000")
      // quebra a parsing do NumericFormat v5 (interpreta "." como ponto
      // decimal e estraga o valor — ex: 15000 vira 15).
      faturamentoEmpresa: response.data.faturamentoEmpresa,
      patrimonioLiquidoEmpresa: response.data.patrimonioLiquidoEmpresa,
      capitalSocialEmpresa: response.data.capitalSocialEmpresa
    };

    response.data = formattedResponse;

    yield put(actions.formatarPessoaJuridica(formattedResponse));

    if (original.successCallback) {
      yield original.successCallback(response, original.value);
    }
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const criarCompradorPessoaJuridica = basicFlow({
  actionGenerator: actions.criarCompradorPessoaJuridicaRequest,
  actionFailure: actions.criarCompradorPessoaJuridicaFailure,
  actionSuccess: actions.criarCompradorPessoaJuridicaSuccess,
  api: apiCriarParticipante,
  postSuccess: function* ({ response, original, values }) {
    if (original.successCallback) {
      yield original.successCallback(response, original.data);
    }
    yield put(
      routeActions.redirectTo(routes.PESSOA_JURIDICA, {
        id: values.value.idOportunidade,
        idPessoaJuridica: response.data.idParticipante
      })
    );
    toast.info('Comprador cadastrado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const editarCompradorPessoaJuridica = basicFlow({
  actionGenerator: actions.editarCompradorPessoaJuridicaRequest,
  actionFailure: actions.editarCompradorPessoaJuridicaFailure,
  actionSuccess: actions.editarCompradorPessoaJuridicaSuccess,
  api: apiEditarParticipante,
  postSuccess: function* ({ response, original, values }) {
    if (original.successCallback) {
      yield original.successCallback(response, original.data);
    }
    yield put(
      routeActions.redirectTo(routes.PESSOA_JURIDICA, {
        id: values.value.idOportunidade,
        idPessoaJuridica: values.value.idParticipante
      })
    );
    toast.info('Comprador editado com sucesso!');
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const buscarCep = basicFlow({
  actionGenerator: actions.buscarCepRequest,
  actionFailure: actions.buscarCepFailure,
  actionSuccess: actions.buscarCepSuccess,
  api: ({ value }) => {
    return unauthenticatedRequest({
      url: `https://viacep.com.br/ws/${value}/json/`,
      method: 'get',
      isCep: true
    });
  },
  postSuccess: function* ({ response, original }) {
    if (!!original.successCallback) {
      yield original.successCallback(response, original.value);
    }
  },
  postFailure: function* (props) {
    if (!!props.original.failureCallback) {
      yield props.original.failureCallback(props);
    }
  }
});

function* mostrarPessoaFisicaRouteWatcher() {
  yield routeWatcher(routes.PESSOA_FISICA, function* () {
    const { idPessoaFisica, id } = yield select(getPayload);
    if (idPessoaFisica === 'novo') {
      yield put(actions.desativarModoEdicao());
      yield put(actions.adicionarOportunidade(id));
      return;
    }
    if (!idPessoaFisica) return;
    yield put(actions.limparPessoaFisica());
    yield put(
      actions.mostrarCompradorPessoaFisicaRequest({
        value: {
          idParticipante: idPessoaFisica,
          idOportunidade: id,
          tipoPessoa: 'F'
        }
      })
    );
    yield put(actions.adicionarOportunidade(id));
    yield put(actions.adicionarParticipante(idPessoaFisica));
  });
}

function* mostrarRepresentanteRouteWatcher() {
  yield routeWatcher(routes.REPRESENTANTE, function* () {
    const { idRepresentante, id, idPessoaJuridica } = yield select(getPayload);
    if (idRepresentante === 'novo') {
      yield put(actions.desativarModoEdicao());
      yield put(actions.adicionarOportunidade(id));
      yield put(actions.adicionarParticipante(idPessoaJuridica));
      return;
    }
    if (!idRepresentante) return;
    yield put(actions.limparRepresentante());
    yield put(
      actions.mostrarRepresentanteRequest({
        value: {
          idParticipante: idPessoaJuridica,
          idRepresentante: idRepresentante,
          tipoSituacao: 'A'
        }
      })
    );
    yield put(actions.adicionarOportunidade(id));
    yield put(actions.adicionarParticipante(idPessoaJuridica));
  });
}

function* mostrarPessoaJuridicaRouteWatcher() {
  yield routeWatcher(
    [routes.PESSOA_JURIDICA, routes.REPRESENTANTE],
    function* () {
      const { idPessoaJuridica, id } = yield select(getPayload);
      if (idPessoaJuridica === 'novo') {
        yield put(actions.desativarModoEdicao());
        yield put(actions.adicionarOportunidade(id));
        return;
      }
      if (!idPessoaJuridica) return;
      yield put(actions.limparPessoaJuridica());
      yield put(
        actions.mostrarCompradorPessoaJuridicaRequest({
          value: {
            idParticipante: idPessoaJuridica,
            idOportunidade: id,
            tipoPessoa: 'J'
          }
        })
      );
      yield put(actions.adicionarOportunidade(id));
      yield put(actions.adicionarParticipante(idPessoaJuridica));
    }
  );
}

function* listarCompradoresRouteWatcher() {
  yield routeWatcher(routes.COMPRADORES, function* () {
    const { id } = yield select(getPayload);
    if (!id) return;
    yield put(actions.listarCompradoresRequest(id));
    yield put(actions.adicionarOportunidade(id));
  });
}

export const sagas = [
  buscarCep.watcher(),
  mostrarCompradorPessoaFisica.watcher(),
  criarCompradorPessoaFisica.watcher(),
  editarCompradorPessoaFisica.watcher(),
  mostrarCompradorPessoaJuridica.watcher(),
  criarCompradorPessoaJuridica.watcher(),
  editarCompradorPessoaJuridica.watcher(),
  listarCompradores.watcher(),
  removerRepresentante.watcher(),
  criarRepresentante.watcher(),
  editarRepresentante.watcher(),
  mostrarRepresentate.watcher(),
  removerParticipante.watcher(),
  buscarConjuge.watcher(),
  mostrarPessoaFisicaRouteWatcher(),
  mostrarPessoaJuridicaRouteWatcher(),
  listarCompradoresRouteWatcher(),
  mostrarRepresentanteRouteWatcher()
];
